<template>
  <div class="instant-message-container">
    <div class="instant-message" :class="{expanded: isExpanded}" v-tooltip.bottom="{content: 'Send quick message', classes: ['brand']}">
      <div class="message-icon" @click="toggleExpand">
        <img src="../../assets/icon_quick_message.svg" v-if="!isExpanded" style="height: 18px;">
        <img src="../../assets/icon_quick_message_brand.svg" v-if="isExpanded" style="height: 18px;">
      </div>
      <div class="text-message">
        <input ref="input" v-model="message" type="text" @click.stop="stopPropagation" @keydown.enter="sendMessage"/>
      </div>
      <div class="send-message" @click.stop="sendMessage">
        <img v-if="message" src="../../assets/icon_send_message.svg" style="height: 18px; margin-top: 3px;"/>
        <img v-if="!message" src="../../assets/icon_clear_brand.svg" style="height: 18px; margin-top: 3px;"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InstantMessage',
    props: {
      localDataTrack: {
        type: Object
      }
    },

    data: () => ({
      isExpanded: false,
      message: null,
      closeTimeout: null
    }),

    methods: {
      toggleExpand() {
        this.isExpanded = !this.isExpanded;
        if(this.isExpanded) {
          this.$refs.input.focus()
        } else {
          this.message = null;
          this.$refs.input.blur();
        }
      },
      onBlur() {
         this.closeTimeout = setTimeout(() => {
            this.message = null;
            this.isExpanded = false
          }, 100)
      },
      sendMessage() {
        clearTimeout(this.closeTimeout);
        if(this.localDataTrack && this.message) {
          this.localDataTrack.send(`M,${this.message}`)
        }
        this.isExpanded = false;
        this.message = null;
        this.$refs.input.blur();
      },
      stopPropagation() {}
    }
  }
</script>

<style lang="scss">
@import "InstantMessage";
</style>
